import { HitlQueueCard } from "./aidwops.types";

const PRIORITY_WEIGHTS = [
    ["severity", 35],
    ["exposure", 25],
    ["urgency", 20],
    ["recurrence", 10],
    ["actionability", 10],
] as const;

export function getRiskTooltip(item: HitlQueueCard, detailed = false): string {
    const formula =
        "Weighted score: severity 35%, exposure 25%, urgency 20%, recurrence 10%, and actionability 10%. Higher scores mean higher review priority; a failing check halves the score.";

    return `Priority ${item.priority.score}/100. ${formula}`;

    // if (!detailed || !item.whyRank?.priority) {
    //     return `Priority ${item.priority.score}/100. ${formula}`;
    // }

    // const factors = item.whyRank.priority.factors;

    // const values = PRIORITY_WEIGHTS.map(
    //     ([key]) => `${key} ${Math.round((factors[key] || 0) * 100)}/100`
    // ).join(", ");

    // const failed = (item.checks || []).some(
    //     (check) =>
    //         check.status === "fail" &&
    //         !check.id.startsWith("prod_") &&
    //         !check.id.startsWith("requester_")
    // );

    // return `Priority ${item.priority.score}/100. ${formula} Factor values: ${values}.${failed ? " A pre-flight check failed, so the weighted score was halved." : ""}`;
}

export function getPriorityTooltip(item: HitlQueueCard, detailed = false): string {
    const basis =
        "Rule-based risk: a failed prohibited-category check sets high risk; a sensitive-category warning raises risk (medium, or high for SSL bypass); otherwise the finding's configured risk is used. A large-change warning can raise recommendation risk to high.";

    return `${item.risk.toUpperCase()} risk. ${basis}`;

    // if (!detailed) {
    //     return `${item.risk.toUpperCase()} risk. ${basis}`;
    // }

    // const checks = item.checks || [];
    // const reasons: string[] = [];

    // const prohibited = checks.find(
    //     (check) => check.id === "not_prohibited" && check.status === "fail"
    // );

    // const sensitive = checks.find(
    //     (check) => check.id === "sensitive_category" && check.status === "warn"
    // );

    // const large = checks.find(
    //     (check) => check.id === "large_change" && check.status === "warn"
    // );

    // if (prohibited) {
    //     reasons.push(`Prohibited-category check failed: ${prohibited.detail}`);
    // }

    // if (sensitive) {
    //     reasons.push(`Sensitive-category warning: ${sensitive.detail}`);
    // }

    // if (large) {
    //     reasons.push(`Large-change warning: ${large.detail}`);
    // }

    // return `${item.risk.toUpperCase()} risk. ${
    //     reasons.join(" ") ||
    //     "No prohibited-category, sensitive-category, or large-change trigger is shown; the displayed level is the backend-assigned risk for this finding."
    // }`;
}
